import { ConfigurationAssaygroupResponse } from '@/modules/configurationModule/detail/assays/configuration-assays-groups/services/configuration-assaygroup/configuration-assaygroup.dto'

export interface ConfigurationAssaysGroupsModalState {
    assaygroup: Partial<ConfigurationAssaygroupResponse>
}
export const initialConfigurationAssaysGroupsModalState =
    (): ConfigurationAssaysGroupsModalState => ({
        assaygroup: {}
    })
